import React from "react";
import { Check, AlertCircle } from "lucide-react";

export default function TargetAudience() {
  const isFor = [
    "Donne tra i 28 e i 45 anni pronte a *guardarsi dentro con sincera onestà*.",
    "Chi ha già provato libri, podcast o terapia ma continua a *ripetere gli stessi schemi*.",
    "Chi si sente *emotivamente prosciugata*, poco scelta ed in una costante *attesa di conferme*.",
    "Chi desidera *riconnettersi profondamente* con i propri *confini, valori e desideri*.",
    "Chi è pronta a *investire tempo ed energie reali* sul proprio *cambiamento personale*."
  ];

  const renderKeywords = (text) =>
    text.split(/(\*[^*]+\*)/g).map((part, i) =>
      part.startsWith("*") && part.endsWith("*") ? (
        <span key={i} className="text-bordeaux font-medium">{part.slice(1, -1)}</span>
      ) : (
        part
      )
    );

  const isNotFor = [
    "Chi cerca tecniche o trucchi di seduzione o manipolazione psicologica.",
    "Chi desidera solo 'riconquistare un ex' o cambiare l'atteggiamento dell'uomo.",
    "Chi non è disposta a mettersi in gioco in prima persona e preferisce rimanere nel ruolo di vittima.",
    "Chi cerca una soluzione magica rapida senza assumersi responsabilità.",
    "Chi non è pronta a dedicare attenzione e riflessione quotidiana per i prossimi 60 giorni."
  ];

  return (
    <section className="py-24 md:py-32 bg-beige font-sans">
      <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-16">
        
        {/* Title */}
        <div className="text-center space-y-4 max-w-2xl mx-auto">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-bordeaux">
            LA QUALIFICAZIONE
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-chocolate font-editorial">
            Questo percorso <span className="italic text-champagne">fa al caso tuo?</span>
          </h2>
          <p className="text-sm sm:text-base leading-relaxed text-chocolate/70 font-light">
            <span className="text-bordeaux font-semibold">BACK TO YOU™</span>
            {" è un'esperienza intensa e selettiva. Non cerchiamo grandi numeri, ma donne pronte per una reale, profonda evoluzione."}
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Per chi è */}
          <div className="bg-white p-10 border border-chocolate/10 space-y-8">
            <div className="flex items-center space-x-3 text-emerald-800">
              <Check className="w-6 h-6" />
              <h3 className="text-xl sm:text-2xl font-normal font-editorial text-chocolate">
                È ideale per te se:
              </h3>
            </div>
            <ul className="space-y-6">
              {isFor.map((item, idx) => (
                <li key={idx} className="flex items-start space-x-4">
                  <span className="w-1.5 h-1.5 bg-bordeaux rounded-full shrink-0 mt-2" />
                  <p className="text-sm sm:text-base text-chocolate/80 font-light leading-relaxed">
                    {renderKeywords(item)}
                  </p>
                </li>
              ))}
            </ul>
          </div>

          {/* Per chi NON è */}
          <div className="bg-bordeaux p-10 border border-champagne/30 space-y-8">
            <div className="flex items-center space-x-3 text-champagne">
              <AlertCircle className="w-6 h-6" />
              <h3 className="text-xl sm:text-2xl font-normal font-editorial text-ivory">
                NON fa per te se:
              </h3>
            </div>
            <ul className="space-y-6">
              {isNotFor.map((item, idx) => (
                <li key={idx} className="flex items-start space-x-4">
                  <span className="w-1.5 h-1.5 bg-champagne/50 rounded-full shrink-0 mt-2" />
                  <p className="text-sm sm:text-base text-ivory/80 font-light leading-relaxed">
                    {item}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>

      </div>
    </section>
  );
}
